// extracted by mini-css-extract-plugin
export default {"container":"AppRedirect_container__W7jcb","loader":"AppRedirect_loader__uOZwM","l3":"AppRedirect_l3__UxDU4"};